import { render, staticRenderFns } from "./ChangePhoneSMSVerification.vue?vue&type=template&id=106df05c&lang=html"
import script from "./ChangePhoneSMSVerification.vue?vue&type=script&lang=js"
export * from "./ChangePhoneSMSVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports